import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { useCommonStore } from './common'
import { useSamudkoyStore } from './samudkoy'
import { getMenuByPage } from '../helpers/getMenuByPage'
import { getSlideByPage } from '../helpers/getSlideByPage'

export const useOverviewStore = defineStore('simakatra.overview', () => {
  const commonStore = useCommonStore()
  const samudkoyStore = useSamudkoyStore()

  /** States */
  const page = ref(1)
  const slide = ref(0) // index 0 to 35

  /** Getters */
  const menu = computed(() => getMenuByPage(page.value))
  const isActivated = computed(() => commonStore.mainContent == 'overview')
  const hasScrollup = /** prev */ computed(() => slide.value > 0)
  const hasScrolldown = /** next */ computed(() => slide.value >= 0 && slide.value < 32)

  /** Actions */
  function setActivePage(newPage: number) {
    page.value = newPage
  }

  function slideToActivePage() {
    slide.value = getSlideByPage(page.value)
    return { slide: slide.value, page: page.value }
  }

  function slideTo(index: number) {
    slide.value = index
    return slide.value
  }

  function slideUp() {
    if (hasScrollup.value) {
      slide.value--
    }
    return slide.value
  }

  function slideDown() {
    if (hasScrolldown.value) {
      slide.value++
    }
    return slide.value
  }

  function showSamudkoyContent() {
    samudkoyStore.page = page.value
    commonStore.mainContent = 'samudkoy'
  }

  return {
    page,
    slide,
    menu,
    isActivated,
    hasScrollup,
    hasScrolldown,
    setActivePage,
    slideToActivePage,
    slideTo,
    slideUp,
    slideDown,
    showSamudkoyContent
  }
})
